<template>
  <v-container grid-list-lg>
    <v-layout v-bind='binding'>
      <v-flex xs12 lg6 order-lg2 class='ma-3'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Select Input
            <v-spacer/>
            <v-btn
              flat
              class='transparent ma-0'
              @click='$refs.legend.show()'
              small
              icon
            >
              <v-icon class='white--text oem-color'>
                help_outline
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
          <div class='img-overlay'>
            <device-image type='voltage'></device-image>
            <div
              v-for='(input, index) in storeState.data.inputs'
              :key='index'
              :style='buttonLocation(index)'
              class='button-holder'
            >
              <selector
                :state='inputState(input)'
                :index='index'
                :selected='index == storeState.selectedInput.id'
                :text='index + 1'
                v-on:selector-clicked='showInput'
              ></selector>
            </div>
          </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <transition name='slide-x-transition'>
        <v-flex xs12 lg6 class='ma-3'>
          <v-card>
            <v-card-title class='headline font-weight-regular oem-color' v-if='initialSetup'>
              Voltage setup menu
            </v-card-title>
            <v-card-title class='headline font-weight-regular oem-color' v-else>
              <template v-if='this.storeState.selectedInput.id === undefined'>
                Voltage Input
              </template>
              <template v-else>
                Voltage Input {{ storeState.selectedInput.id + 1 }}
              </template>
            </v-card-title>
            <v-card-text>
              <div v-if='initialSetup'>
                <p>This menu allows configuration of the voltage input</p>
                <div class='inline-selector'>Click "Halo-dot"</div>
                <div class='inline-selector'>
                  <selector
                    :state='inputState(storeState.data.inputs[0])'
                    :index='0'
                    :disabled='true'
                    :text='1'
                    class='reverse-selector'
                  ></selector>
                </div>
                <div class='inline-selector' v-if='storeState.data.inputs.length === 2'>
                  or
                </div>
                <div class='inline-selector' v-if='storeState.data.inputs.length === 2'>
                  <selector
                    :state='inputState(storeState.data.inputs[1])'
                    :index='1'
                    :disabled='true'
                    :text='2'
                    class='reverse-selector'
                  ></selector>
                </div>
                <div>near connector to begin voltage input setup.</div>
              </div>
              <div class='ma-3' v-else>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-validate="'numeric|min_value:0|max_value:100000'"
                      data-vv-name="voltage"
                      :error-messages="errors.collect('voltage')"
                      v-model.number='storeState.selectedInput.voltage'
                      :label=' storeState.selectedInput.service === 2 || storeState.selectedInput.service === 3 ? "Expected voltage on L1-L2 (VAC)" : "Expected voltage on L1 (VAC)"'
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model='actualVoltage'
                      :label='storeState.selectedInput.service === 2 || storeState.selectedInput.service === 3 ? "Actual voltage on L1-L2 (VAC)" : "Actual voltage on L1 (VAC)"'
                      readonly
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs11>
                    <v-select
                      v-model='storeState.selectedInput.service'
                      :items='storeState.serviceOptions'
                      label='Service type'
                      @change='changeType()'
                    >
                    </v-select>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn
                      absolute
                      flat
                      class='mt-3 transparent oem-text-color'
                      icon
                      @click='helpDialog = true'
                    >
                      <v-icon>
                        help_outline
                      </v-icon>
                    </v-btn>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-validate="'required|decimal|min_value:0.001|max_value:1000'"
                      data-vv-name="voltage scaler"
                      :error-messages="errors.collect('voltage scaler')"
                      v-model.number='storeState.selectedInput.voltageScaler'
                      label="Voltage scaler"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-switch
                      v-model='changeWiring'
                      label='Service wiring correction'
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12 v-if='changeWiring'>
                    <div>
                      <v-select v-for='n in servicePhases()'
                      :key=n
                        v-model='storeState.selectedInput.lines[n-1].channel'
                        :items='lines[storeState.selectedInput.id]'
                        :label="`L${n}-connector`"
                        @change='validate()'
                        :error-messages='errorMsg'
                      ></v-select>
                    </div>
                    <!--
                      <div v-else-if='servicePhases() === 1'>
                        <v-select v-for='n in 1'
                      :key=n
                        v-model='storeState.selectedInput.lines[n-1].channel'
                        :items='lines[storeState.selectedInput.id]'
                        :label="`L${n}-connector`"
                        @change='validate()'
                        :error-messages='errorMsg'
                      ></v-select>
                   </div>
                   -->
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
             <v-card-actions v-if='!initialSetup'>
              <v-spacer></v-spacer>
              <v-btn
                class='oem-button'
                flat
                @click='save'
                :disabled='errors.any()'
              >
                Save
              </v-btn>
              <v-btn
                class='oem-button'
                flat
                @click='clear'
              >
                Defaults
              </v-btn>
            </v-card-actions>
            <v-card-actions v-else>
              <v-spacer></v-spacer>
               <v-btn
                class='oem-button'
                flat
                @click='showInput(0)'
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </transition>
      <v-dialog v-model='helpDialog' max-width='800px'>
        <v-card>
          <v-card-title class='headline font-weight-regular oem-color'>
            Legend
          </v-card-title>
          <v-card-text>
            <div
              v-for='(service, index) in storeState.serviceOptions'
              :key=index
            >
                  <h1>{{ service.text }}</h1>
                  <v-img :src=serviceImages[index] aspect-ratio='2' contain></v-img>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class='oem-button' flat @click='helpDialog = false'>
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <helpLegend ref='legend' page='input'></helpLegend>
    </v-layout>
    <msgDialog
      ref='dialogDeleteLoads'
      v-bind:title='`Confirm`'
      v-bind:msg='dialogDeleteLoadsText'
    />
  </v-container>
</template>

<script>
import msgDialog from './BaseDialog.vue';
import selector from './BaseSelector.vue';
import helpLegend from './BaseLegend.vue';
import deviceImage from './BaseDeviceImage.vue';
import ajax from '../ajax';

const oneW = require('../assets/img/1w.png');
const twoW = require('../assets/img/2w.png');
const threeWD = require('../assets/img/3w-d.png');
const fourWW = require('../assets/img/4w-w.png');

export default {
  name: 'Voltage',
  components: {
    selector,
    helpLegend,
    deviceImage,
    msgDialog,
  },
  computed: {
    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndDown) binding.column = true;

      return binding;
    },
  },
  data() {
    return {
      serviceImages: [
        fourWW, threeWD, twoW, oneW,
      ],
      storeState: this.$store.state,
      initialSetup: false,
      selectedInput: 0,
      lines: [[
        { text: 'L1', value: 0 },
        { text: 'L2', value: 1 },
        { text: 'L3', value: 2 },
      ], [
        { text: 'L1', value: 3 },
        { text: 'L2', value: 4 },
        { text: 'L3', value: 5 },
      ]],
      styles: ['green--text ', 'red--text ', 'orange--text ', 'grey--text '],
      svgStyles: ['green ', 'red ', 'orange ', 'grey '],
      legend: ['Fully configured', 'Used by load but unconfigured', 'Configured but not used by any load', 'Unused'],
      legendDialog: false,
      helpDialog: false,
      errorMsg: [],
      buttonLocation12: [
        { top: '17.8%', left: '83.8%' },
        { top: '17.8%', left: '15.5%' },
      ],
      buttonLocation48: [
        { top: '7.0%', left: '71.5%' },
        { top: '7.0%', left: '28.4%' },
      ],
      actualVoltage: 'No voltage present',
      changeWiring: false,
      dialogDeleteLoadsText: '',
    };
  },
  methods: {
    compareInts(a, b) {
      if (Number(a) === Number(b)) {
        return true;
      }
      return false;
    },
    showInput(input) {
      this.initialSetup = false;
      this.storeState.selectedInput = JSON.parse(
        JSON.stringify(this.storeState.data.inputs[input]),
      );
      let serviceWiringApplied = false;
      if (this.storeState.selectedInput.lines[0].active && this.storeState.selectedInput.lines[0].channel !== -1) {
        if (this.storeState.selectedInput.lines[0].channel !== (this.storeState.selectedInput.id * 3) + 0) {
          serviceWiringApplied = true;
        }
      }
      if (this.storeState.selectedInput.lines[1].active && this.storeState.selectedInput.lines[1].channel !== -1) {
        if (this.storeState.selectedInput.lines[1].channel !== (this.storeState.selectedInput.id * 3) + 1) {
          serviceWiringApplied = true;
        }
      }
      if (this.storeState.selectedInput.lines[2].active && this.storeState.selectedInput.lines[2].channel !== -1) {
        if (this.storeState.selectedInput.lines[2].channel !== (this.storeState.selectedInput.id * 3) + 2) {
          serviceWiringApplied = true;
        }
      }
      this.changeWiring = serviceWiringApplied;
    },
    buttonLocation(index) {
      if (this.storeState.data.deviceInfo.model === 48) {
        return this.buttonLocation48[index];
      }
      return this.buttonLocation12[index];
    },
    inputState(input) {
      let state = 0;
      if ((input.active && input.service !== 0) && input.used) {
        state = 0;
      } else if (!(input.active && input.service !== 0) && input.used) {
        state = 1;
      } else if ((input.active && input.service !== 0) && !input.used) {
        state = 2;
      } else if (!(input.active && input.service !== 0) && !input.used) {
        state = 3;
      }
      return state;
    },
    servicePhases() {
      // eslint-disable-next-line
      const service = this.storeState.selectedInput.service;
      let phases = 0;
      if (service === 1
          || service === 2
          || service === 3) {
        phases = 3;
      } else if (service === 4) {
        phases = 2;
      } else if (service === 5) {
        phases = 1;
      }
      return phases;
    },
    changeType() {
      for (let i = 0; i < 3; i += 1) {
        this.storeState.selectedInput.lines[i].channel = this.storeState.selectedInput.id * 3 + i;
      }
      this.validate();
    },
    validate() {
      // the valid variable is used throughout the whole validation process.
      let valid = true; // eslint-disable-line no-unused-vars
      if (!this.changeWiring) {
        this.storeState.selectedInput.lines[0].channel = (this.storeState.selectedInput.id * 3) + 0;
        this.storeState.selectedInput.lines[1].channel = (this.storeState.selectedInput.id * 3) + 1;
        this.storeState.selectedInput.lines[2].channel = (this.storeState.selectedInput.id * 3) + 2;
      }
      const l1 = this.storeState.selectedInput.lines[0].channel;
      const l2 = this.storeState.selectedInput.lines[1].channel;
      const l3 = this.storeState.selectedInput.lines[2].channel;


      this.errorMsg = [];

      if (this.servicePhases() === 3) {
        if (l1 === -1 || l2 === -1 || l3 === -1) {
          valid = false;
        } else if (!(l1 !== l2 && l2 !== l3 && l3 !== l1)) {
          this.errorMsg.push('Cannot use the same wire for multiple lines.');
          valid = false;
        } else {
          this.storeState.selectedInput.lines[0].active = true;
          this.storeState.selectedInput.lines[1].active = true;
          this.storeState.selectedInput.lines[2].active = true;
        }
        if (this.storeState.selectedInput.voltage === null) {
          valid = false;
        }
      } else if (this.servicePhases() === 2) {
        if (l1 === -1 || l2 === -1) {
          valid = false;
        } else if (l1 === l2) {
          this.errorMsg.push('Cannot use the same wire for multiple lines.');
          valid = false;
        } else {
          this.storeState.selectedInput.lines[0].active = true;
          this.storeState.selectedInput.lines[1].active = true;
        }
        this.storeState.selectedInput.lines[2].channel = -1;
        if (this.storeState.selectedInput.voltage === null) {
          valid = false;
        }
      } else if (this.servicePhases() === 1) {
        if (l1 === -1) {
          valid = false;
        } else {
          this.storeState.selectedInput.lines[0].active = true;
        }
        this.storeState.selectedInput.lines[1].channel = -1;
        this.storeState.selectedInput.lines[2].channel = -1;
        if (this.storeState.selectedInput.voltage === null) {
          valid = false;
        }
      } else if (this.servicePhases() === 0 && (this.storeState.selectedInput.voltage !== null && this.storeState.selectedInput.voltage !== 0)) {
        valid = false;
      } else if (this.servicePhases() === 0) { // Default (not active)
        valid = true;
      } else {
        valid = false;
      }

      this.storeState.selectedInput.active = this.servicePhases() !== 0;
    },
    clear() {
      this.storeState.selectedInput.service = 0;
      this.storeState.selectedInput.voltage = null;
      this.storeState.selectedInput.voltageScaler = 1.0;
      this.storeState.selectedInput.lines[0].channel = -1;
      this.storeState.selectedInput.lines[1].channel = -1;
      this.storeState.selectedInput.lines[2].channel = -1;
      this.storeState.selectedInput.active = false;
      // this.$refs.form.resetValidation();
    },
    save() {
      this.validate();
      this.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            if (this.storeState.selectedInput.service !== this.storeState.data.inputs[this.storeState.selectedInput.id].service // Service type has changed
                && this.storeState.data.loads.filter(load => load.input === this.storeState.selectedInput.id).length) { // And loads are configured for this input
              this.dialogDeleteLoadsText = `Changing the service type of an input will remove all loads configured for that input. Are you sure you want to save the change and remove assigned loads for input ${this.storeState.selectedInput.id + 1}?`;
              this.$refs.dialogDeleteLoads
                .pop()
                .then(() => {
                  // loop into alarms and delete relevant ones
                  const delList = [];
                  for (let ai = 0; ai < this.storeState.data.alarms.length; ai += 1) {
                    const presentAlarm = this.storeState.data.alarms[ai];
                    // Delete Line related alarms
                    if (this.storeState.alarmTypes.find(t => t.value === presentAlarm.type).lineApplicable) {
                      const Lines = this.storeState.data.inputs[this.storeState.selectedInput.id].lines;
                      for (let lineIdx = 0; lineIdx < Lines.length; lineIdx += 1) {
                        if (Lines[lineIdx].active && presentAlarm.vinLineLoadOrCt === Lines[lineIdx].channel) {
                          delList.push(ai);
                        }
                      }
                    }
                    // Delete load related alarms
                    if (this.storeState.alarmTypes.find(t => t.value === presentAlarm.type).loadApplicable) {
                      for (let i = 0; i < this.storeState.data.loads.length; i += 1) {
                        if (presentAlarm.vinLineLoadOrCt === this.storeState.data.loads[i].id && this.storeState.data.loads[i].input === this.storeState.selectedInput.id) {
                          delList.push(ai);
                          break;
                        }
                      }
                    }
                    // Delete vin related alarms
                    if (this.storeState.alarmTypes.find(t => t.value === presentAlarm.type).vinApplicable) {
                      if (presentAlarm.vinLineLoadOrCt === this.storeState.selectedInput.id) {
                        delList.push(ai);
                      }
                    }
                  }

                  // delete load->ct related alarms
                  const tempLoads = this.storeState.data.loads.filter(load => load.input === this.storeState.selectedInput.id);
                  tempLoads.forEach((load) => {
                    for (let i = 0; i < 3; i += 1) {
                      if (load.cts[i].active) {
                        for (let ai = 0; ai < this.storeState.data.alarms.length; ai += 1) {
                          if (this.storeState.alarmTypes.find(t => t.value === this.storeState.data.alarms[ai].type).ctApplicable) {
                            if (this.storeState.data.alarms[ai].vinLineLoadOrCt === load.cts[i].channel - 6) {
                              delList.push(ai);
                            }
                          }
                        }
                      }
                    }
                  });

                  // Sort and Traverse through the list of alarms which needs to be deleted
                  delList.sort((a, b) => b - a);
                  for (let index = 0; index < delList.length; index += 1) {
                    this.deleteAlarm(this.storeState.data.alarms[delList[index]]);
                  }

                  // Reset load index for alarms
                  const remainedLoads = this.storeState.data.loads.filter(load => load.input !== this.storeState.selectedInput.id);
                  let initialVinLineLoadCT = 0;
                  let alarmFoundWithLoad = false;
                  for (let rmIndex = 0; rmIndex < remainedLoads.length; rmIndex += 1) {
                    for (let aIndex = 0; aIndex < this.storeState.data.alarms.length; aIndex += 1) {
                      if (this.storeState.alarmTypes.find(t => t.value === this.storeState.data.alarms[aIndex].type).loadApplicable) {
                        if (this.storeState.data.alarms[aIndex].vinLineLoadOrCt === remainedLoads[rmIndex].id) {
                          this.storeState.data.alarms[aIndex].vinLineLoadOrCt = initialVinLineLoadCT;
                          alarmFoundWithLoad = true;
                        }
                      }
                    }
                    if (alarmFoundWithLoad) {
                      initialVinLineLoadCT += 1;
                      alarmFoundWithLoad = false;
                    }
                  }

                  this.storeState.data.loads = this.storeState.data.loads.filter(load => load.input !== this.storeState.selectedInput.id);
                  this.storeState.loadDirty = true;
                  this.storeState.data.loads.forEach((value, key) => {
                    value.id = key;
                  });
                  const obj = JSON.parse(JSON.stringify(this.storeState.selectedInput));
                  this.$set(this.storeState.data.inputs, this.storeState.selectedInput.id, obj);

                  this.storeState.ctDirty = true;
                  this.$store.updateCts();
                  this.$store.updateVdis();
                  this.$store.updateInputs();
                  this.storeState.voltageDirty = true;
                  this.showInput(this.storeState.selectedInput.id);
                })
                .catch(() => {});
            } else {
              const obj = JSON.parse(JSON.stringify(this.storeState.selectedInput));
              this.$set(this.storeState.data.inputs, this.storeState.selectedInput.id, obj);
              this.storeState.voltageDirty = true;
              this.showInput(this.storeState.selectedInput.id);
            }
          }
        });
    },
    deleteAlarm(item) {
      const index = this.storeState.data.alarms.indexOf(item);
      if (index !== undefined) {
        this.storeState.data.alarms.splice(index, 1);
        for (let i = index; i < this.storeState.data.alarms.length; i += 1) {
          this.storeState.data.alarms[i].id -= 1;
        }
      }
      this.storeState.alarmsDirty = true;
    },
    updateVoltage() {
      const inp = this.storeState.selectedInput.id;
      if (inp !== -1 && inp !== undefined) {
        ajax.get('data/inputs')
          .then((response) => {
            if (this.storeState.selectedInput.id !== -1) {
              if (this.storeState.selectedInput.service === 2 || this.storeState.selectedInput.service === 3) {
                this.actualVoltage = this.formatNumber(response.data.Input[this.storeState.selectedInput.id].lines[0].v_ll, 3);
              } else {
                this.actualVoltage = this.formatNumber(response.data.Input[this.storeState.selectedInput.id].lines[0].v, 3);
              }
              if (this.actualVoltage === '0.000') {
                this.actualVoltage = 'No voltage present';
              }
            }
          })
          .catch((e) => {
            console.log(e); // eslint-disable-line no-console
            this.actualVoltage = 'No voltage present';
          });
      }
    },
    formatNumber(number, decimals) {
      return parseFloat(Math.round(number * (10 ** decimals)) / (10 ** decimals)).toFixed(decimals);
    },
    setInitialSelectedInputWhenAvailable() {
      if (this.storeState.data.inputs.length !== 0) {
        if (this.storeState.data.inputs[0].active || this.storeState.data.inputs[1].active) {
          this.storeState.selectedInput = JSON.parse(JSON.stringify(this.storeState.data.inputs[0]));
          this.showInput(0);
        } else {
          this.initialSetup = true;
        }
        this.$timer.stop('setInitialSelectedInputWhenAvailable');
      }
    },
  },
  timers: {
    updateVoltage: { time: 1000, repeat: true, autostart: true },
    setInitialSelectedInputWhenAvailable: { time: 100, repeat: true, autostart: false },
  },
  mounted() {
    const inp = this.storeState.selectedInput.id;
    if (inp === undefined) {
      if (this.storeState.data.inputs.length === 0) { // Not yet loaded
        this.$timer.start('setInitialSelectedInputWhenAvailable');
      } else if (this.storeState.data.inputs[0].active || this.storeState.data.inputs[1].active) {
        this.storeState.selectedInput = JSON.parse(JSON.stringify(this.storeState.data.inputs[0]));
        this.showInput(0);
      } else {
        this.initialSetup = true;
      }
    } else {
      this.storeState.selectedInput = JSON.parse(JSON.stringify(this.storeState.data.inputs[inp]));
      this.showInput(0);
    }
  },
};
</script>
